import React from 'react';
import { BrandColor } from '@styleseat/brand';

type VariousCrownIconProps = {
  width?: number;
  height?: number;
  color?: BrandColor;
} & React.SVGProps<SVGSVGElement>;

export const VariousCrownIcon = ({
  width = 24,
  height = 25,
  color = BrandColor.BackInBlack,
}: VariousCrownIconProps) => (

  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5777 15.5029L16.5 7.2375L15.7039 7.03681L13.5621 12.0327L12.3583 6.50293L11.5466 6.50683L10.4049 12.0035L8.3 7.04071L7.5 7.22971L8.25922 15.5029H15.5777Z"
      fill={color}
    />
  </svg>
);
